import { useEffect, useState } from 'react';
import {
  getManagedContext,
  getManagingInvitations
} from 'services/managed-blocking.service';
import { hasManagedBlockingContext } from 'utils/managed-blocking.util';

// Drives the sidebar entry. Lookup failures leave it hidden: the page stays reachable by URL, and a
// navigation item must never block or error the rest of the app.
export const useHasManagedBlockingContext = (): boolean => {
  const [hasContext, setHasContext] = useState(false);
  useEffect(() => {
    let isActive = true;
    Promise.all([getManagedContext(), getManagingInvitations()])
      .then(([context, invitations]) => {
        if (isActive) {
          setHasContext(hasManagedBlockingContext(context, invitations));
        }
      })
      .catch(() => undefined);
    return () => {
      isActive = false;
    };
  }, []);
  return hasContext;
};
